import { useState } from 'react';
import { useCatalog } from '../lib/catalog';
import { setState, type VideoLang } from '../lib/store';
import { navigate, useLocation } from '../lib/router';

export function Onboarding() {
  const { topics: TOPICS } = useCatalog();
  const { query } = useLocation();
  const next = query.get('next') || '/home';
  const [picked, setPicked] = useState<string[]>(['govt', 'money', 'english']);
  const [lang, setLang] = useState<VideoLang>('Both');

  const toggle = (slug: string) =>
    setPicked((p) => (p.includes(slug) ? p.filter((x) => x !== slug) : [...p, slug]));

  const finish = (skip = false) => {
    setState({ onboarded: true, interests: skip ? [] : picked, videoLang: lang });
    navigate(next, { replace: true });
  };

  return (
    <div className="onboard">
      <div className="onboard-top">
        <div className="steps-dots" aria-label="Step 2 of 2"><span className="on" /><span className="on" /></div>
        <button type="button" className="text-link muted" onClick={() => finish(true)}>Skip</button>
      </div>
      <h1>Hi! What do you like to watch?</h1>
      <p className="muted">Pick at least 3. We will suggest shows for you.</p>
      <div className="interest-grid">
        {TOPICS.map((t) => {
          const on = picked.includes(t.slug);
          return (
            <button key={t.slug} type="button" className={'interest' + (on ? ' on' : '')} aria-pressed={on} onClick={() => toggle(t.slug)}>
              <b>{t.name}</b>
              <small>{t.blurb}</small>
            </button>
          );
        })}
      </div>
      <div className="stack-sm">
        <span className="label" id="lang-label">Video language</span>
        <div className="segmented" role="radiogroup" aria-labelledby="lang-label">
          {(['Hindi', 'English', 'Both'] as VideoLang[]).map((l) => (
            <button key={l} type="button" role="radio" aria-checked={lang === l} className={lang === l ? 'on' : ''} onClick={() => setLang(l)}>{l}</button>
          ))}
        </div>
      </div>
      <button type="button" className="btn btn-lg btn-primary btn-block onboard-go" disabled={picked.length < 3} onClick={() => finish()}>
        {picked.length < 3 ? `Pick ${3 - picked.length} more` : `Start · ${picked.length} picked`}
      </button>
    </div>
  );
}
